import React from "react";

// CardCollectionSimulatorView embeds the standalone simulator HTML (served by the dev tool) in an
// iframe, passing the currently selected dev server so the simulator fetches that server's live
// card collection configs from consul.
const CardCollectionSimulatorView = ({ dev }) => {
	if (!dev) {
		return (
			<div style={{ padding: 24, color: "#888" }}>
				Select a dev server (top-right) to load its card collection configs.
			</div>
		);
	}

	const src =
		"/card_collection_simulator.html?dev=" + encodeURIComponent(dev);

	return (
		<iframe
			title="Card Collection Simulator"
			src={src}
			style={{
				width: "100%",
				height: "calc(100vh - 96px)",
				border: "none",
				borderRadius: 8,
				background: "#0d0d1a",
			}}
		/>
	);
};

export default CardCollectionSimulatorView;
